import React from 'react';
import {FocusedNoData} from "./FocusedLoader";
import ProductListByValue from "../products/ProductListByValue";
import CustomTimer from "../../../../components/CustomTimer";


const FocusedItemsProductView = ({
                                   focused: {data, init} = {},
                                   mobile,
                                   type, showTitle, noRedux, isNavOverlay
                                 }) => {


  const _endDate = data?.flash_sale && data?.items?.length && data.items[0]?.data?.end_date ? data.items[0].data.end_date : undefined;

  return (
    <div className="relative">

      <CustomTimer mobile={mobile} endDate={_endDate} isFlashSale={false} className="absolute top-3 left-0 right-0"/>

      {init && data?.items?.length ?
        <>
          {
            data.items.map((i) =>

                <ProductListByValue value={i.value} mobile={mobile} type={type} title={(data?.extras?.show_title ?? false) ? i.title : ""}
                                    key={i.id} noRedux={noRedux} isNavOverlay={isNavOverlay}
                                    image={i.image_url} imageWeb={i.image_url_web}/>
            )
          }
        </>
        : <FocusedNoData/>}
    </div>
  );
};

export const MemoizedFocusedItemsProductView = React.memo(FocusedItemsProductView);

